var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"counter"},[_c('span',[_c('span',{class:{valid: _vm.countIsValid},domProps:{"textContent":_vm._s(_vm.value)}}),_vm._v(" / "+_vm._s(_vm.minCount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }